"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _Card = _interopRequireDefault(require("./Card"));
var _Video = _interopRequireDefault(require("./Video"));
var _Txt = _interopRequireDefault(require("./Txt"));
var _classnames = _interopRequireDefault(require("classnames"));
function ProductResource(props) {
  var style = props.style,
    flexTitle = props.flexTitle,
    desc = props.desc,
    cardData = props.cardData,
    videoData = props.videoData,
    txtData = props.txtData,
    onClick = props.onClick,
    type = props.type,
    paddingTopNum = props.paddingTopNum,
    paddingBottomNum = props.paddingBottomNum,
    mergeComponentStatus = props.mergeComponentStatus;
  var layoutMode = (txtData || {}).layoutMode;
  var _a = (cardData || {}).configuration,
    configuration = _a === void 0 ? [] : _a;
  var cardDataShow = true;
  if (configuration.length < 1) {
    cardDataShow = false;
  }
  var _b = (videoData || {}).configuration,
    videoList = _b === void 0 ? [] : _b;
  var videoDataShow = true;
  if (videoList.length < 1) {
    videoDataShow = false;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-product-resource-container', {
      'padding-top-pc60-mo40': paddingTopNum === '60',
      'padding-top-pc40-mo24': paddingTopNum === '40',
      'padding-top-pc0-mo0': paddingTopNum === '0',
      'padding-bottom-pc60-mo40': paddingBottomNum === '60',
      'padding-bottom-pc40-mo24': paddingBottomNum === '40',
      'padding-bottom-pc0-mo0': paddingBottomNum === '0'
    }),
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'product-resource-container'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"]
  // style={{padding:'60px 24px 12px 24px'}}
  , {
    // style={{padding:'60px 24px 12px 24px'}}
    title: flexTitle,
    desc: desc,
    paddingTopNum: '0',
    mergeComponentStatus: mergeComponentStatus
  }), (0, _typeof2["default"])(cardData) === 'object' ? ( /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    data: cardData,
    onClick: onClick,
    isPadding: true
  })) : null, (0, _typeof2["default"])(videoData) === 'object' ? ( /*#__PURE__*/_react["default"].createElement(_Video["default"], {
    data: videoData,
    type: type,
    hasTopPadding: cardDataShow,
    isPadding: true
  })) : null, (0, _typeof2["default"])(txtData) === 'object' ? ( /*#__PURE__*/_react["default"].createElement(_Txt["default"], {
    data: txtData,
    type: type,
    hasTopPadding: cardDataShow || videoDataShow,
    layoutMode: layoutMode,
    isPadding: true
  })) : null));
}
var _default = exports["default"] = ProductResource;